$(document).ready(function () {

  $("#Companies_country").on('change', function () {
    changeRegData();
  });

  changeRegData();

  function changeRegData() {
    var type_jur = $('option:selected', $("#Companies_country")).data('jurisdiction');
    var type_j;

    if ('OTHER' == type_jur || 'USA' == type_jur) {
      type_j = 2;
    } else if ('EU' == type_jur) {
      type_j = 3;
    } else if ('RU' == type_jur) {
      type_j = 1;
    }

    $('.hidden').removeClass('hidden');
    $('.display_not_' + type_j).addClass('hidden');
    $('#companies_type_id').val(type_j);
  }

  function collectFields() {
    var getContract = true;

    var companyName  = $('#Companies_companyName');
    var address      = $('#Companies_address');
    var address_post = $('#Companies_address_post');
    var inn          = $('#Companies_inn');
    var kpp          = $('#Companies_kpp');
    var ogrn         = $('#Companies_ogrn');
    var bik          = $('#Companies_bik');
    var rschet       = $('#Companies_rschet');
    var regNumber    = $('#Companies_reg_number');
    var vat          = $('#Companies_vat');

    var jurisdiction_value = $('#Companies_jurisdiction').val();

    var company_id = $('#Companies_id');

    if (!companyName.val().length) {
      getContract = false;

      if (!companyName.parents('.col-md-4').find('.alert').length) {
        companyName.parents('.col-md-4')
          .append('<div class="alert alert-danger margin-top-5 fade in">' + translate.company_empty_name + '</div>');
      }
    }

    if (!address.val().length) {
      getContract = false;

      if (!address.parents('.col-md-4').find('.alert').length) {
        address.parents('.col-md-4')
          .append('<div class="alert alert-danger fade in">' + translate.company_address + '</div>');
      }
    }


    if (!address_post.val().length) {
      getContract = false;

      if (!address_post.parents('.col-md-4').find('.alert').length) {
        address_post.parents('.col-md-4')
          .append('<div class="alert alert-danger fade in">' + translate.company_address_post + '</div>');
      }
    }

    var type_jur = $('option:selected', $("#Companies_country")).data('jurisdiction');
    if (typeof type_jur == 'undefined') {
      type_jur = $('#Companies_type_jur').val();
    }

    if (type_jur == 'RU') {
      if (!inn.val().length) {
        getContract = false;

        if (!inn.parents('.col-md-4').find('.alert').length) {
          inn.parents('.col-md-4')
            .append('<div class="alert alert-danger fade in">' + translate.company_inn + '</div>');
        }
      }

      if (!kpp.val().length) {
        getContract = false;

        if (!kpp.parents('.col-md-4').find('.alert').length) {
          kpp.parents('.col-md-4')
            .append('<div class="alert alert-danger fade in">' + translate.company_kpp + '</div>');
        }
      }

      if (!ogrn.val().length) {
        getContract = false;

        if (!ogrn.parents('.col-md-4').find('.alert').length) {
          ogrn.parents('.col-md-4')
            .append('<div class="alert alert-danger fade in">' + translate.company_ogrn + '</div>');
        }
      }

      if (!bik.val().length) {
        getContract = false;

        if (!bik.parents('.col-md-4').find('.alert').length) {
          bik.parents('.col-md-4')
            .append('<div class="alert alert-danger fade in">' + translate.company_bik + '</div>');
        }
      }

      if (!rschet.val().length) {
        getContract = false;

        if (!rschet.parents('.col-md-4').find('.alert').length) {
          rschet.parents('.col-md-4')
            .append('<div class="alert alert-danger fade in">' + translate.company_schet + '</div>');
        }
      }
    }

    if (!getContract) {
      return false;
    }

    return {
      YII_CSRF_TOKEN: token,
      type_jur:       type_jur,
      companyName:    companyName.val(),
      contractId:     company_id.val(),
      company_id:     company_id.val(),
      ogrn:           ogrn.val(),
      vat:            vat.val(),
      inn:            inn.val(),
      kpp:            kpp.val(),
      address:        address.val(),
      address_post:   address_post.val(),
      regNumber:      regNumber.val(),
      jurisdiction:   jurisdiction_value,
      bik:            bik.val(),
      rschet:         rschet.val(),
      nopics:         $('#Companies_nopics').val()
    }
  }


  $('.download_contract').click(function (event) {
    event.preventDefault();

    var data = collectFields();

    if (false != data) {
      $('.activityPace').css('display', 'inline-block');

      $.ajax({
          url:  '/files/generateContractTemplate',
          type: 'POST',
          data: data
        })
        .done(function (response) {
          response = JSON.parse(response);
          if (response.code == 0) {
            $('.activityPace').css('display', 'none');
            location.href = '/files/getFile/?id=' + parseInt(response.response);
          }
        })
        .fail(function (response) {
          $('.activityPace').css('display', 'none');
        });
    }
  });

  $('body').on('click', '.company_get_addiction', function (event) {
    event.preventDefault();

    var data = collectFields();
    var that = $(this);

    if (false != data) {
      data.addition = 1;

      $.ajax({
          url:  '/files/generateContractTemplate',
          type: 'POST',
          data: data
        })
        .done(function (response) {
          response = JSON.parse(response);
          if (response.code == 0) {
            documentStatusWidget('.' + that.attr('class'), [parseInt(response.response)]).done(function(file_ids) {
              location.href = '/files/getFile/?id=' + file_ids[0];
            });
          }
        });
    }
  });

});
